import React, { memo } from 'react'
import Box from '@mui/material/Box'
import NextImage from 'next/legacy/image'

const Image = ({
  width,
  height,
  sx: sxProp = {},
  layout = 'fill',
  objectFit = 'contain',
  className,
  ...other
}) => {
  const dimensions = { width, height, position: 'relative' }
  return (
    <>
      {layout === 'fill'
        ? (
          <Box
            sx={{ ...dimensions, ...sxProp }}
            className={className}
          >
            <NextImage
              layout={layout}
              objectFit={objectFit}
              {...other}
            />
          </Box>
        )
        : (
          <NextImage
            layout={layout}
            objectFit={objectFit}
            {...dimensions}
            {...other}
          />
        )}
    </>
  )
}

export default memo(Image)
